export var UI_EVENT_TYPE = 'ui';
export var TRACK_EVENT_TYPE = 'track';
export var SCREEN_EVENT_TYPE = 'screen';
export var OPERATIONAL_EVENT_TYPE = 'operational';
export var DEFAULT_SOURCE = 'unknown';